import { ClassValue } from "clsx";
import { ReactNode } from "react";
import { Typography } from "@drpcrd/shared/ui";
import { CreatorOSLogo } from "./icons/creatoros-logo";

type HeaderContainerProps = {
  children: ReactNode;
};

const HeaderContainer = ({ children }: HeaderContainerProps) => (
  <header className="sticky top-0 z-10 block flex w-full items-center justify-center bg-white py-2.5">
    {children}
  </header>
);

const HeaderTitle = ({ title }: { title: string }) => (
  <Typography className="grow text-sm! lg:text-lg!" weight="semibold">
    {title}
  </Typography>
);

type HeaderProps = {
  title?: string;
  logoClassName?: ClassValue;
  children?: ReactNode;
};

/**
 * Mobile header component that displays the CreatorOS logo and optional title.
 */
export const MobileHeader = ({ title, children }: HeaderProps) => (
  <HeaderContainer>
    {children || (
      <div className="w-full max-w-56 px-2 sm:px-1!">
        <CreatorOSLogo className="h-3" />
        {title && <HeaderTitle title={title} />}
        <div className="grow" />
      </div>
    )}
  </HeaderContainer>
);
